import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #33: A Map of Global Migrations, Part 2",
  "description": "",
  "published": "2017-02-13T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-33-map-global-migrations-part-2/swizec/7436"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://liveedu.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`This Sunday, we built a colorful map and discovered that a marathon is 138,435 feet long. I don't know why Google thinks that's a useful answer to `}<em parentName="p">{`"How long is a marathon?”`}</em>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/02/map.gif",
        "alt": null
      }}></img></p>
    <p>{`Our map shows migrations `}<em parentName="p">{`into`}</em>{` the selected country and uses color to show migration magnitude. The more people that moved into a country in 2015, the warmer the color of that country and its curve. Or rather, the more to the right on the `}<inlineCode parentName="p">{`d3.interpolateWarm`}</inlineCode>{` color scale.`}</p>
    <p><img parentName="p" {...{
        "src": "https://raw.githubusercontent.com/d3/d3-scale/master/img/warm.png",
        "alt": null
      }}></img></p>
    <p>{`I wouldn't describe green as warmer than purple… to be honest, I'm not sure what exactly `}<inlineCode parentName="p">{`interpolateWarm`}</inlineCode>{` is meant to correspond to. But the way we used it, to the right is more and to the left is less. `}<em parentName="p">{`shrug`}</em></p>
    <p>{`Guess we'll have to add a legend next week ?`}</p>
    <p>{`But first, the curves. `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-32-map-global-migrations/swizec/7415"
      }}>{`Last week`}</a>{`, we discovered that a curve between two points is a straight line. We fixed that by adding a middle point calculated `}<a parentName="p" {...{
        "href": "http://www.virtualnerd.com/algebra-1/radical-expressions-equations/distance-midpoint-formulas/midpoint-formula/midpoint-between-coordinates"
      }}>{`using high school geometry`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/02/midpoint-screenshot.jpg",
        "alt": null
      }}></img></p>
    <p>{`Our new `}<inlineCode parentName="p">{`Curve`}</inlineCode>{` component looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const Curve = ({ start, end, color }) => {
    const line = d3.line()
                   .curve(d3.curveBasis),
          [x1, y1] = start,
          [x2, y2] = end,
          middle = [(x1 + x2)/2, (y1 + y2)/2-200];

    return (
        <path d="{line([start," middle,="" end])}="" style="{{stroke:" color,="" strokewidth:="" '1.6px',="" strokeopacity:="" '0.7',="" fillopacity:="" 0}}="">
    );
};
</path>
`}</code></pre>
    <p>{`A line generator with a curve interpolator, some geometry for the `}<inlineCode parentName="p">{`middle`}</inlineCode>{` point pulled up by `}<inlineCode parentName="p">{`-200`}</inlineCode>{` pixels, and returns a `}<inlineCode parentName="p">{`<path>`}</inlineCode>{` element of a given color, and some other styling. We got the `}<inlineCode parentName="p">{`-200`}</inlineCode>{` number by fiddling around until it looked good.`}</p>
    <p>{`That and some looping created a map with very many curves all over it. It was not very useful.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/02/map-with-all-curves.png",
        "alt": null
      }}></img></p>
    <p>{`nikivansevdon suggested we add some sort of filtering, and daemon92 had great ideas around colors and highlighting source countries on the map itself. Thanks guys!`}</p>
    <p>{`So we used `}<a parentName="p" {...{
        "href": "https://github.com/JedWatson/react-select"
      }}>{`react-select`}</a>{` to make a drop down and spent far too much time rejigging our calculations to make the map aware of them. This is where having Redux or MobX becomes useful: When you want to move things around.`}</p>
    <p>{`With those, you have data and calculations in a global state somewhere. With our haphazard approach, most logic gets slapped into the nearest component that uses it. It works great until you want to move something, then you're in a world of pain.`}</p>
    <p>{`Watch `}<a parentName="p" {...{
        "href": "https://www.liveedu.tv/swizec/videos/Oxp87-a-map-of-global-migrations-in-react-d3-3"
      }}>{`the stream recording`}</a>{` from about 1h20min onwards. You'll see what I mean. Copy-pasting. So much copy-pasting :D`}</p>
    <p>{`You can see the final `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/migrations-map/blob/10c93fb29117f7b0b84c30a2f598ec2efc72a957/src/Maps.js"
      }}>{`code on Github`}</a>{`.`}</p>
    <p>{`It came out quite well I think.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/02/colourful-map.gif",
        "alt": null
      }}></img></p>
    <p>{`Next week, we'll add useful text info, a color legend, and add some animation to make the visualization quicker to understand. I want to add something that shows directionality for those curves.`}</p>
    <p>{`If we can get special regions like World, Developed countries, etc. to work, that would be great too. ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      